import React from 'react';

const MyPassengersNotFound = () => {
	return (
		<div className="my-passengers-not-found-results">
			<span>
				<p className="lead">Você não possui nenhuma venda :(</p>
			</span>
		</div>
	);
};

export default MyPassengersNotFound;